import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import BlogDetails from "./components/blog/blogDetails";
import BlogGrid from "./components/blog/blogGrid";
import BlogList from "./components/blog/bloglist";
import BlogMasonry from "./components/blog/blogMasonry";
import BlogModern from "./components/blog/blogModern";
import Cart from "./components/pages/cart";
import JobCategory from "./components/pages/category";
import Checkout from "./components/pages/checkout";
import AddCourse from "./components/pages/course/addCourse";
import CourseDetails from "./components/pages/course/courseDetails";
import CourseDetails1 from "./components/pages/course/courseDetails1";
import CourseDetails2 from "./components/pages/course/courseDetails2";
import CourseGrid from "./components/pages/course/courseGrid";
import CourseLesson from "./components/pages/course/courseLesson";
import CourseList from "./components/pages/course/courseList";
import ComingSoon from "./components/pages/error/comingSoon";
import Error404 from "./components/pages/error/error404";
import Error500 from "./components/pages/error/error500";
import UnderConstruction from "./components/pages/error/underConstruction";
import Faq from "./components/pages/faq";
import ForgotPassword from "./components/pages/forgotPassword";
import Login from "./components/pages/login";
import Notification from "./components/pages/notification";
import PrivacyPolicy from "./components/pages/policy";
import PricingPlan from "./components/pages/pricingPlan";
import PricingPlan2 from "./components/pages/pricingPlan/pricingPlan2";
import Register from "./components/pages/register";
import RegisterOne from "./components/pages/register/register1";
import RegisterTwo from "./components/pages/register/register2";
import RegisterThree from "./components/pages/register/register3";
import RegisterFour from "./components/pages/register/register4";
import RegisterFive from "./components/pages/register/register5";
import Support from "./components/pages/support";
import TermsCondition from "./components/pages/termsCondition";
import Wishlist from "./components/pages/wishlist";
import EditorinchiefIndividual from "./components/instructor/profile/profileById";

//harish
import { Home } from "./components/home";
import { Home2 } from "./components/home2";
import { Home3 } from "./components/home3";
import { Home4 } from "./components/home4";
import { Dashboard } from "./components/instructor/dashboard";
import { InstructorList } from "./components/instructor/list";
import InstructorGrid from "./components/instructor/grid";
import InstructorCourse from "./components/instructor/course";
import InstructorReviews from "./components/instructor/reviews";
import InstructorEarnings from "./components/instructor/earnings";
import InstructorOrders from "./components/instructor/orders";
import InstructorPayouts from "./components/instructor/payouts";
import InstructorEditProfile from "./components/instructor/editProfile";
import InstructorSecurity from "./components/instructor/security";
import InstructorSocialProfile from "./components/instructor/socialProfiles";
import InstructorNotification from "./components/instructor/notification";
import InstructorTickets from "./components/instructor/tickets";
import InstructorChat from "./components/instructor/chat";
import InstructorDeleteProfile from "./components/instructor/deleteProfile";
import InstructorEdit from "./components/instructor/edit";
import InstructorGrid2 from "./components/instructor/grid2";
import InstructorLinkedAccount from "./components/instructor/linkedAccount";
import InstructorNewTickets from "./components/instructor/newTickets";
import InstructorProfile from "./components/instructor/profile";
import InstructorProfilePrivacy from "./components/instructor/profilePrivacy";
import InstructorStudentGrid from "./components/instructor/studentGrid";
import InstructorStudentList from "./components/instructor/studentList";
import StudentEditProfile from "./components/student/AuthorInstructions/author";
import MalPracticeAuthor from "./components/student/AuthorInstructions/malpractice";
import StudentAccounts from "./components/student/accounts";
import StudentBilling from "./components/student/billing";
import StudentDeleteProfile from "./components/student/deleteProfile";
import StudentInvoice from "./components/student/invoice";
import StudentNotification from "./components/student/notification";
import StudentPayment from "./components/student/payment";
import StudentPrivacy from "./components/student/privacy";
import StudentReferral from "./components/student/referral";
import StudentSecurity from "./components/student/security";
import StudentSocialProfile from "./components/student/socialProfile";
import StudentSubscription from "./components/student/subscription";
import StudentNewTickets from "./components/student/newTickets";
import StudentTickets from "./components/student/tickets";
import StudentViewTickets from "./components/student/viewTickets";
import StudentProfile from "./components/student/profile";
import StudentsGrid from "./components/student/grid";
import StudentsGrid2 from "./components/student/grid2";
import StudentsList from "./components/student/list";
import InstructorDepositDashboard from "./components/instructor/deposit";
import StudentDepositDashboard from "./components/student/depositDashboard";
import DashboardInstructor from "./components/instructor/dashboardInstructor";
import WithdrawalInstructor from "./components/instructor/withdrawalInstructor";
import DepositInstructor from "./components/instructor/depositInstructor";
import TransactionInstructor from "./components/instructor/transactionInstructor";
import DepositStudent from "./components/student/depositStudent";
import TransactionStudent from "./components/student/transactionStudent";
import JournalHome from './components/Journal/journalhome'
import CourseMessage from "./components/student/courseMessage";
import CourseWishlist from "./components/student/courseWishlist";
import CourseStudent from "./components/student/courseStudent";
import PurchaseHistory from "./components/student/purchaseHistory";
import ViewInvoice from "./components/student/invoice/viewInvoice";
import NewPassword from "./components/pages/newPassword";
import SubmitMenuscript from "./components/newpages/submitMenuscript";
// import Articles from "./components/newpages/articles";
import Archive from "./components/newpages/archive";
import Guidelines from "./components/newpages/guidelines";
import UpcomingIssues from "./components/newpages/upcomingissues";
import JournalContact from "./components/newpages/journalcontact";
import JournalFilter from "./components/newpages/journalfilter";
import OnlineSubmissionJournalfilter from "./components/newpages/onlineSubmissionjournal";
import SubjectFilter from "./components/newpages/subjectfilter";
import Editorialpolicies from "./components/newpages/editorialpolicies";
import Onlinesubmission from "./components/newpages/onlinesubmission";
import Authorinstruction from "./components/newpages/authorinstruction";
import Policies from "./components/newpages/policies";
import PublicationEthics from "./components/newpages/publicationEthics";
import Reviewers from "./components/newpages/reviewers";
import TermsandConditions from "./components/newpages/termsandconditions";
import Covid from "./components/newpages/covid";
import Advertising from "./components/newpages/advertising";
import Confrences from "./components/newpages/conferences";
import ContactUs from "./components/newpages/contactUs";
import VolumePage from "./components/newpages/volume-page";
import MainVolume from "./components/newpages/mainVolume";
import AthorPage from "./components/newpages/authorPage";
import Journalpage from "./components/newpages/testing-pages/journalpage";
import JournalHightlight from "./components/newpages/testing-pages/highlightJournal";
import AimsandScope from "./components/newpages/aimsAndScope";
import ManunScriptFrom from './components/newpages/manuscriptForm';
import MoreCalssifications from "./components/newpages/moreClassifications";
import MoreBrowseBySubject from "./components/newpages/moreBrowseBySubject";
import ArchiveHtml from "./components/newpages/archiveHtml";
import ArticleHtml from "./components/newpages/articleHtml";
import AbstractData from "./components/newpages/abstract"
import AuthorInfoJournal from "./components/newpages/authorInfoJournal";
// import JournalArchive from "./components/newpages/journArchieve";

import PaymentCreate from "./components/newpages/paymentCreate";
import Toolspage from "./components/footer/footerpages/tools/tools";
import Careerspage from "./components/footer/footerpages/careers/careers";
import Privacypolicypage from "./components/footer/footerpages/privacypolicy/privacypolicy";
import Termsandconditionspage from "./components/footer/footerpages/TermsAndconditions/termsandconditions";
import AuthorsReviewerpage from "./components/footer/footerpages/AuthorsReviewerEditor/AuthorsReviewer";
import MakePayment from "./components/newpages/makePayment";
import CardDetails from "./components/newpages/CardDetails";
const Approuter = () => {
  return (
    <BrowserRouter basename="/">
      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/:slug/archive" element={<JournalArchive />} /> */}
        {/* <Route path="/:slug/more-calssifications" element={<MoreCalssifications />} /> */}
        <Route path="/classifications/:slug" element={<MoreCalssifications />} />

        {/* <Route path="/:slug/more-Subject" element={<MoreBrowseBySubject />} /> */}
        <Route path="/Subject/:slug" element={<MoreBrowseBySubject />} />

        <Route path="/home2" element={<Home2 />} />
        <Route path="/home3" element={<Home3 />} />
        <Route path="/home4" element={<Home4 />} />
        <Route path="/instructor-dashboard" element={<Dashboard />} />
        <Route path="/instructor-list" element={<InstructorList />} />
        <Route path="/instructor-grid" element={<InstructorGrid />} />
        <Route path="/instructor-course" element={<InstructorCourse />} />
        <Route path="/journal-test1" element={<JournalHome />} />
        {/* Blog */}
        <Route path="/blog-list" element={<BlogList />} />
        <Route path="/blog-grid" element={<BlogGrid />} />
        <Route path="/blog-masonry" element={<BlogMasonry />} />
        <Route path="/blog-modern" element={<BlogModern />} />
        <Route path="/blog-details" element={<BlogDetails />} />

        {/* Pages */}
        <Route path="/page-notification" element={<Notification />} />
        <Route path="/pricing-plan" element={<PricingPlan />} />
        <Route path="/pricing-plan2" element={<PricingPlan2 />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/add-course" element={<AddCourse />} />
        <Route path="/course-list" element={<CourseList />} />
        <Route path="/course-grid" element={<CourseGrid />} />
        <Route path="/course-details" element={<CourseDetails />} />
        <Route path="/course-details1" element={<CourseDetails1 />} />
        <Route path="/course-details2" element={<CourseDetails2 />} />
        <Route path="/course-lesson" element={<CourseLesson />} />
        <Route path="/come-soon" element={<ComingSoon />} />
        <Route path="/error-404" element={<Error404 />} />
        <Route path="/error-500" element={<Error500 />} />
        <Route path="/under-construction" element={<UnderConstruction />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/support" element={<Support />} />
        <Route path="/job-category" element={<JobCategory />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/login" element={<Login />} />
        <Route path="/new-password" element={<NewPassword />} />
        <Route path="/register" element={<Register />} />
        <Route path="/register1" element={<RegisterOne />} />
        <Route path="/register2" element={<RegisterTwo />} />
        <Route path="/register3" element={<RegisterThree />} />
        <Route path="/register4" element={<RegisterFour />} />
        <Route path="/register5" element={<RegisterFive />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/term-condition" element={<TermsCondition />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        {/* Instructor Routes */}
        <Route path="/:slug/instructor-profile/:details/:type" element={<EditorinchiefIndividual />} />
        <Route path="/instructor-dashboard" element={<Dashboard />} />
        <Route path="/:slug/editor-board" element={<InstructorList />} />
        <Route path="/journal-grid" element={<InstructorGrid />} />
        <Route path="/instructor-course" element={<InstructorCourse />} />
        {/* <Route path="/:slug/journal-articles" element={<InstructorReviews />} /> */}
        <Route path="/:slug/articles_in_process" element={<InstructorReviews />} />
        <Route path="/instructor-earnings" element={<InstructorEarnings />} />
        <Route path="/instructor-orders" element={<InstructorOrders />} />
        <Route path="/instructor-payouts" element={<InstructorPayouts />} />
        <Route path="/instructor-tickets" element={<InstructorTickets />} />
        <Route path="/:slug/editor-in-chief" element={<InstructorProfile />} />
        <Route
          path="/instructor-edit-profile"
          element={<InstructorEditProfile />}
        />
        <Route path="/instructor-security" element={<InstructorSecurity />} />
        <Route
          path="/instructor-social-profile"
          element={<InstructorSocialProfile />}
        />
        <Route
          path="/instructor-notifications"
          element={<InstructorNotification />}
        />
        <Route path="/instructor-chat" element={<InstructorChat />} />
        <Route
          path="/instructor-delete-profile"
          element={<InstructorDeleteProfile />}
        />
        <Route path="/instructor-edit" element={<InstructorEdit />} />
        <Route path="/instructor-grid-2" element={<InstructorGrid2 />} />
        <Route
          path="/instructor-linked-account"
          element={<InstructorLinkedAccount />}
        />
        <Route
          path="/instructor-new-tickets"
          element={<InstructorNewTickets />}
        />
        <Route
          path="/instructor-profile-privacy"
          element={<InstructorProfilePrivacy />}
        />
        <Route
          path="/instructor-student-grid"
          element={<InstructorStudentGrid />}
        />
        <Route
          path="/instructor-student-list"
          element={<InstructorStudentList />}
        />
        <Route
          path="/deposit-instructor-dashboard"
          element={<InstructorDepositDashboard />}
        />
        <Route path="/dashboard-instructor" element={<DashboardInstructor />} />
        <Route
          path="/withdrawal-instructor"
          element={<WithdrawalInstructor />}
        />
        <Route path="/deposit-instructor" element={<DepositInstructor />} />
        <Route
          path="/transactions-instructor"
          element={<TransactionInstructor />}
        />

        {/* New Pages */}

        {/* <Route path="/:slug/journal-aim-scope" element={<AimsandScope />} /> */}
        <Route path="/:slug/indexing" element={<AimsandScope />} />
        {/* <Route path="/:slug/journal-submitmanuscript" element={<SubmitMenuscript />} /> */}
        <Route path="/:slug/submitmanuscript" element={<SubmitMenuscript />} />


        {/* <Route path="/:slug/journal-archive" element={<Archive />} /> */}
        <Route path="/:slug/archive" element={<Archive />} />

        {/* <Route path="/:slug/journal-guidelines" element={<Guidelines />} /> */}
        <Route path="/:slug/guidelines" element={<Guidelines />} />
        {/* <Route path="/:slug/journal-upcoming" element={<UpcomingIssues />} /> */}

        <Route path="/:slug/upcoming_special_issue" element={<UpcomingIssues />} />

        {/* <Route path="/:slug/journal-contact" element={<JournalContact />} /> */}
        <Route path="/:slug/contact" element={<JournalContact />} />


        {/* <Route path="/filter/:slug/:name" element={<JournalFilter />} /> */}
        <Route path="/filter/:name" element={<JournalFilter />} />
        <Route path="/online-submission" element={<OnlineSubmissionJournalfilter />} />
        {/* <Route path="/subject-filter/:slug/:name" element={<SubjectFilter />} /> */}
        <Route path="/subject-filter/:name" element={<SubjectFilter />} />

        <Route path="/editorial-policies/:name" element={<Editorialpolicies />} />
        {/* Dynamic pageData */}
        <Route path="/:name" element={<Editorialpolicies />} />

        <Route path="/online-submission/:name" element={<Onlinesubmission />} />
        <Route path="/author-instructions/:name" element={<Authorinstruction />} />
        <Route path="/policies/:name" element={<Policies />} />
        <Route path="/publication-ethics/:name" element={<PublicationEthics />} />
        <Route path="/reviewers/:name" element={<Reviewers />} />
        <Route path="/terms-and-conditions/:name" element={<TermsandConditions />} />
        <Route path="/covid-special" element={<Covid />} />
        <Route path="/advertising/:name" element={<Advertising />} />
        <Route path="/confrences/:name" element={<Confrences />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/:slug/volume-page/:name" element={<VolumePage />} />
        <Route path="/:slug/archive/:ArchiveHtml" element={<ArchiveHtml />} />
        <Route path="/:slug/article/:ArticleHtml" element={<ArticleHtml />} />
        <Route path="/:slug/abstract/:ArticleHtml" element={<AbstractData />} />
        <Route path="/:slug/author/:ArticleHtml/:type" element={<AuthorInfoJournal />} />
        <Route path="/main-volume" element={<MainVolume />} />
        <Route path="/athor-page" element={<AthorPage />} />
        {/* <Route path="/:slug/journal-home" element={<Journalpage />} /> */}
        <Route path="/:slug/home" element={<Journalpage />} />

        <Route path="/journal-highlight/:title/:content" element={<JournalHightlight />} />
        <Route path="/:slug/manuscript-form" element={<ManunScriptFrom />} />


        {/*Student Routes  */}
        <Route path="/:slug/instructios-for-authors" element={<StudentEditProfile />} />
        <Route path="/:slug/publication-malpractice-statement" element={<MalPracticeAuthor />} />
        <Route path="/setting-student-accounts" element={<StudentAccounts />} />
        <Route path="/setting-student-billing" element={<StudentBilling />} />
        <Route
          path="/setting-student-delete-profile"
          element={<StudentDeleteProfile />}
        />
        <Route path="/setting-student-invoice" element={<StudentInvoice />} />
        <Route path="/view-invoice" element={<ViewInvoice />} />
        <Route
          path="/setting-student-notification"
          element={<StudentNotification />}
        />
        <Route path="/setting-student-payment" element={<StudentPayment />} />
        <Route path="/setting-student-privacy" element={<StudentPrivacy />} />
        <Route path="/setting-student-referral" element={<StudentReferral />} />
        <Route path="/setting-student-security" element={<StudentSecurity />} />
        <Route
          path="/setting-student-social-profile"
          element={<StudentSocialProfile />}
        />
        <Route
          path="/setting-student-subscription"
          element={<StudentSubscription />}
        />
        <Route
          path="/setting-support-new-tickets"
          element={<StudentNewTickets />}
        />
        <Route path="/setting-support-tickets" element={<StudentTickets />} />
        <Route
          path="/setting-support-view-tickets"
          element={<StudentViewTickets />}
        />
        <Route
          path="/deposit-student-dashboard"
          element={<StudentDepositDashboard />}
        />
        <Route path="/students-profile" element={<StudentProfile />} />
        <Route path="/students-grid" element={<StudentsGrid />} />
        <Route path="/students-grid2" element={<StudentsGrid2 />} />
        <Route path="/journal-author" element={<StudentsList />} />
        <Route path="/course-student" element={<CourseStudent />} />
        <Route path="/course-wishlist" element={<CourseWishlist />} />
        <Route path="/course-message" element={<CourseMessage />} />
        <Route path="/purchase-history" element={<PurchaseHistory />} />
        <Route path="/deposit-student" element={<DepositStudent />} />
        <Route path="/transactions-student" element={<TransactionStudent />} />

        <Route path="/payments" element={<PaymentCreate />} />
         <Route path="/make-payment" element={<MakePayment/>}/>
        {/* footer */}
        <Route path="/tools" element={<Toolspage />} />
        <Route path="/careers" element={<Careerspage />} />
        <Route path="/privacypolicy" element={<Privacypolicypage />} />
        <Route path="/termsAndCondtions" element={<Termsandconditionspage />} />
        <Route path="/authors-Reviewers-editors" element={<AuthorsReviewerpage />} />

        <Route path="/card-details" element={<CardDetails />} />

      </Routes>
    </BrowserRouter>
  );
};

export default Approuter;
